var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnicornHire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 122,
    viewBox: "0 0 121 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5,
    cy: 61,
    rx: 60.5,
    ry: 61,
    fill: "#EEC89A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2770_15288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 61C67.5167 61 73.7666 58.4188 78.3746 53.8241C82.9827 49.2295 85.5714 42.9978 85.5714 36.5C85.5714 30.0022 82.9827 23.7705 78.3746 19.1759C73.7666 14.5812 67.5167 12 61 12C54.4833 12 48.2334 14.5812 43.6254 19.1759C39.0173 23.7705 36.4286 30.0022 36.4286 36.5C36.4286 42.9978 39.0173 49.2295 43.6254 53.8241C48.2334 58.4188 54.4833 61 61 61ZM52.2272 70.1875C33.3188 70.1875 18 85.4617 18 104.315C18 107.454 20.5531 110 23.7013 110H98.2987C101.447 110 104 107.454 104 104.315C104 85.4617 88.6813 70.1875 69.7728 70.1875H52.2272Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2770_15288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 98,
    fill: "white",
    transform: "translate(18 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicornHire);
export default __webpack_public_path__ + "static/media/Unicorn-hire.82aa5d4bdcc33d9bd337fca1a2745e7b.svg";
export { ForwardRef as ReactComponent };